// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SettingsNavigationSection-base__o8AAk{display:flex;flex-direction:column;gap:var(--size-0_5);align-items:flex-start;align-self:stretch;padding:var(--size-0)}.SettingsNavigationSection-sectionHeader__EUkVc{padding:var(--size-1) var(--size-2_5);color:var(--text-subtle);font:var(--font-caption-medium-400);font-feature-settings:var(--feature-settings-caption-medium-400);letter-spacing:var(--letter-spacing-caption-medium-400)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "SettingsNavigationSection-base__o8AAk",
	"sectionHeader": "SettingsNavigationSection-sectionHeader__EUkVc"
};
export default ___CSS_LOADER_EXPORT___;
